// The SSO UI lives at sso.hocnhe.com; API requests use api-sso.hocnhe.com.
export const SSO_API_BASE_URL = import.meta.env.VITE_SSO_API_BASE_URL || 'https://api-sso.hocnhe.com';

export const AUTH_ENDPOINTS = {
  register: '/v1/auth/register',
  login: '/v1/auth/login',
  logout: '/v1/auth/logout',
  refresh: '/v1/auth/refresh',
  me: '/v1/auth/me',
  verifyEmail: '/v1/auth/verify-email',
  resendVerification: '/v1/auth/resend-verification',
  forgotPassword: '/v1/auth/forgot-password',
  resetPassword: '/v1/auth/reset-password',
  google: '/v1/auth/google',
  totpVerify: '/v1/auth/totp/verify',
  exchangeCode: '/v1/auth/exchange-code',
} as const;

export const getAuthURL = (endpoint: keyof typeof AUTH_ENDPOINTS): string =>
  `${SSO_API_BASE_URL}${AUTH_ENDPOINTS[endpoint]}`;

export const AUTH_URLS = Object.fromEntries(
  (Object.keys(AUTH_ENDPOINTS) as Array<keyof typeof AUTH_ENDPOINTS>)
    .map((key) => [key, getAuthURL(key)]),
) as { [K in keyof typeof AUTH_ENDPOINTS]: string };
